$('.primaryMenu-toggler').on('click', function(){
	$('body').toggleClass('menu-open');
});

$('.primaryMenu-link').each(function( index ) {
	$(this).css({'transition-delay': `${index * .1 + .65}s`})
});
